import {useObserver} from './useObserver'
import {isomorphicObserver} from 'quickstart/utils/isomorphic-observer'

/**
 * Use a callback ref with IntersectionObserver.
 */
export const useIntersectionObserver = (
  options?: IntersectionObserverInit & {enabled?: boolean},
) => useObserver(isomorphicObserver('IntersectionObserver'), options)
